import type { MouseEvent } from 'react';
import { useCallback } from 'react';

import { CloseIcon } from '~components/icons/CloseIcon';

type TagProps = {
  onClear?: () => void;
  label: string;
};

export function Tag({ onClear, label }: TagProps) {
  // Handler: external onClear callback
  const handleOnClear = useCallback(
    (evt: MouseEvent<HTMLButtonElement>) => {
      evt.stopPropagation();
      onClear?.();
    },
    [onClear],
  );

  return (
    <div className="ml--tag inline-flex px-2 py-1 items-center rounded bg-gray text-black font-sans text-sm select-none whitespace-nowrap">
      {label}
      <button
        className="ml--tag--clear appearance-none p-0 ml-1 -mr-1 border-none outline-none bg-transparent cursor-pointer text-metal hover:text-black"
        onClick={handleOnClear}
      >
        <CloseIcon className="w-4 h-4 text-current" />
      </button>
    </div>
  );
}
